'use strict';

bbw.model.ForumAreasTrait = {

    loadForumAreas: function() {
        this.adminOnlyAreas = [];
        this.descs = [];
        this.subtypesArray = [];
        return this._rpcClient.get('post-collections/forum').execute().then(function(response) {
            this.subtypes = response.post_collections.reduce(function(carry, item) {
                if (item.admin_only) {
                    this.adminOnlyAreas.push(item.id);
                }
                var tokens = ('' + item.title).split(/\s*\|\s*/);
                var area = {
                    id: item.id,
                    title: tokens[0],
                    idx: item.order_idx
                };
                area.toString = function() { return tokens[0]; };
                this.subtypesArray.push(area);
                return carry[item.id] = area, this.descs[item.id] = tokens[1], carry;
            }.bind(this), {});
            this.areas = angular.copy(this.subtypesArray);
            if (bbw.userIsModerator) {
                this.subtypes['unmoderated'] = bbw.messages.unmoderated;
                this.subtypesArray.push({
                    id: 'unmoderated',
                    title: bbw.messages.unmoderated,
                    idx: 9999999999
                });
            }
        }.bind(this));
    }

};
